import React, { useContext, useEffect, useState } from 'react';
import {
    Avatar,
    Badge, Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fade,
    Grid2 as Grid,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader, TextField,
    Typography,
    useColorScheme
} from "@mui/material";
import {
    AddLocationAltRounded,
    ArrowBackIosNew,
    BookOnline,
    CloseRounded,
    DarkModeRounded,
    Dialpad,
    FavoriteBorder,
    Gavel,
    Grain,
    HelpCenter,
    LightModeRounded,
    LogoutRounded,
    PersonRounded,
    PowerSettingsNew,
    ShoppingCart,
    SupportAgent,
    Wallet
} from "@mui/icons-material";
import { Support_add } from "../network/api/support.api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorContext } from "./GympinPagesProvider";
import { getUserAvatarSrc } from "../helper/utils";
import { useFavorites } from "../helper/FavoritesContext";

const DrawerLayout = ({ setMenuOpen }) => {
    const userBasket = useSelector((state) => state.invoice.userBasket);
    const { count: favoritesCount } = useFavorites();
    const navigate = useNavigate();

    const handleNav = (path) => {
        if (setMenuOpen) setMenuOpen(false);
        navigate(path);
    };

    const [openModalExit, setOpenModalExit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openModalRegister, setOpenModalRegister] = useState(false);
    const currentUser = useSelector(state => state.auth.user);
    const error = useContext(ErrorContext);

    const [formData, setFormData] = useState({
        gymName: '',
        gymAddress: '',
        gymPhone: '',
        description: ''
    });
    const [errors, setErrors] = useState({});
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const { mode, systemMode, setMode } = useColorScheme();
    const isDark = (mode === "system" ? systemMode : mode) === "dark";

    useEffect(() => {
        if (openModalRegister)
            setLoading(false);
    }, [openModalRegister]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.gymName) newErrors.gymName = 'نام مجموعه ضروری است';
        if (!formData.gymAddress) newErrors.gymAddress = 'آدرس ضروری است';
        if (!formData.gymPhone) newErrors.gymPhone = 'شماره تماس ضروری است';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        setLoading(true);
        Support_add({
            Title: "درخواست افزودن مجموعه " + formData.gymName,
            UserId: currentUser.Id,
            PlaceId: null,
            CorporateId: null,
            Message: {
                Message: "درخواست افزودن " + formData.gymName + " با شماره " + formData.gymPhone + " با آدرس " + formData.gymAddress + " را دارم اطلاعات اضافی : " + formData.description,
                IsRead: false,
                IsAnswer: false
            }
        }).then(result => {
                setLoading(false);
                setSubmitSuccess(true);
                setFormData({
                    gymName: '',
                    gymAddress: '',
                    gymPhone: '',
                    description: '',
                });
                setTimeout(() => {
                    error.showError({ message: "ثبت درخواست با موفقیت انجام شد", });
                    setOpenModalRegister(false)
                }, 2000);
            }).catch(e => {
                setLoading(false);
                try {
                    error.showError({ message: e.response.data.Message, });
                } catch (f) {
                    error.showError({ message: "خطای نامشخص", });
                }
            });
    };


    function renderModalExit() {
        return (
            <Dialog
                open={openModalExit}
                onClose={() => setOpenModalExit(false)}
                TransitionComponent={Fade}
                transitionDuration={250}
                PaperProps={{
                    sx: {
                        position: "relative",
                        borderRadius: "24px",
                        p: { xs: 2.5, sm: 3 },
                        maxWidth: 500,
                        width: "calc(100% - 32px)",
                        mx: "auto",
                        textAlign: "center",
                        overflow: "hidden",
                        background: isDark
                            ? "linear-gradient(180deg, #242424 0%, #181818 100%)"
                            : "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
                        boxShadow: "0 24px 48px -12px rgba(0, 0, 0, 0.25)",
                        border: "1px solid",
                        borderColor: isDark ? "rgba(231, 51, 62, 0.25)" : "rgba(231, 51, 62, 0.12)",
                    }
                }}
                BackdropProps={{
                    sx: {
                        backdropFilter: "blur(8px)",
                        backgroundColor: isDark ? "rgba(0, 0, 0, 0.65)" : "rgba(0, 0, 0, 0.4)",
                        transition: "all 0.3s ease"
                    }
                }}
            >
                {/* دکمه بستن سریع */}
                <IconButton
                    size="small"
                    onClick={() => setOpenModalExit(false)}
                    sx={{
                        position: "absolute",
                        top: 14,
                        left: 14,
                        color: "text.disabled",
                        bgcolor: isDark ? "rgba(255, 255, 255, 0.06)" : "rgba(0, 0, 0, 0.04)",
                        borderRadius: "50%",
                        transition: "all 0.2s ease",
                        "&:hover": {
                            bgcolor: isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)",
                            color: "text.primary",
                            transform: "rotate(90deg)"
                        }
                    }}
                >
                    <CloseRounded fontSize="small" />
                </IconButton>

                {/* آیکون خروج با هاله نوری و انیمیشن ملایم */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mx: "auto",
                        mb: 2,
                        mt: 0.5,
                        width: 72,
                        height: 72,
                        borderRadius: "50%",
                        bgcolor: "rgba(231, 51, 62, 0.08)",
                        border: "1px solid rgba(231, 51, 62, 0.18)",
                        boxShadow: "0 8px 24px -4px rgba(231, 51, 62, 0.25)"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 52,
                            height: 52,
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, rgba(231, 51, 62, 0.2) 0%, rgba(178, 40, 49, 0.12) 100%)",
                            color: "primary.main"
                        }}
                    >
                        <LogoutRounded sx={{ fontSize: 28, transform: "scaleX(-1)" }} />
                    </Box>
                </Box>

                {/* عنوان مدال */}
                <DialogTitle
                    sx={{
                        p: 0,
                        mb: 1,
                        fontWeight: 800,
                        fontSize: "1.2rem",
                        color: "text.primary",
                        letterSpacing: "-0.3px"
                    }}
                >
                    خروج از حساب کاربری
                </DialogTitle>

                {/* توضیحات مدال */}
                <DialogContent sx={{ p: 0, mb: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "text.secondary",
                            lineHeight: 2,
                            fontSize: "0.88rem",
                            px: 1
                        }}
                    >
                        آیا برای خروج از حساب خود در جیم‌پین اطمینان دارید؟
                    </Typography>
                </DialogContent>

                {/* دکمه‌های عملیاتی */}
                <DialogActions
                    sx={{
                        p: 0,
                        display: "flex",
                        gap: 1.5,
                        width: "100%",
                        justifyContent: "stretch"
                    }}
                >
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => setOpenModalExit(false)}
                        sx={{
                            flex: 1,
                            py: 1.25,
                            borderRadius: "14px",
                            fontWeight: 700,
                            fontSize: "0.92rem",
                            color: isDark ? "#d4d4d4" : "#525252",
                            borderColor: isDark ? "rgba(255, 255, 255, 0.12)" : "#e5e5e5",
                            bgcolor: isDark ? "rgba(255, 255, 255, 0.04)" : "#fafafa",
                            boxShadow: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                                bgcolor: isDark ? "rgba(255, 255, 255, 0.08)" : "#f5f5f5",
                                borderColor: isDark ? "rgba(255, 255, 255, 0.2)" : "#d4d4d4",
                                boxShadow: "none"
                            }
                        }}
                    >
                        انصراف
                    </Button>

                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            setOpenModalExit(false);
                            handleNav("/logout");
                        }}
                        endIcon={<LogoutRounded sx={{ fontSize: "1.15rem !important", transform: "scaleX(-1)" }} />}
                        sx={{
                            flex: 1,
                            py: 1.25,
                            borderRadius: "14px",
                            fontWeight: 700,
                            fontSize: "0.92rem",
                            color: "#ffffff",
                            background: "linear-gradient(135deg, #e7333e 0%, #b22831 100%)",
                            boxShadow: "0 6px 18px rgba(231, 51, 62, 0.35)",
                            transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                background: "linear-gradient(135deg, #f14651 0%, #e7333e 100%)",
                                boxShadow: "0 8px 24px rgba(231, 51, 62, 0.45)",
                                transform: "translateY(-1px)"
                            },
                            "&:active": {
                                transform: "translateY(1px)"
                            }
                        }}
                    >
                        خروج
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }



    function renderModalRegister() {
        return (
            <Dialog
                open={openModalRegister}
                onClose={() => setOpenModalRegister(false)}
                TransitionComponent={Fade}
                transitionDuration={250}
                PaperProps={{
                    sx: {
                        position: "relative",
                        borderRadius: "24px",
                        p: { xs: 2.5, sm: 3 },
                        maxWidth: 480,
                        width: "calc(100% - 32px)",
                        mx: "auto",
                        overflow: "hidden",
                        background: isDark
                            ? "linear-gradient(180deg, #242424 0%, #181818 100%)"
                            : "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
                        boxShadow: "0 24px 48px -12px rgba(0, 0, 0, 0.25)",
                        border: "1px solid",
                        borderColor: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)",
                    }
                }}
                BackdropProps={{
                    sx: {
                        backdropFilter: "blur(8px)",
                        backgroundColor: isDark ? "rgba(0, 0, 0, 0.65)" : "rgba(0, 0, 0, 0.4)"
                    }
                }}
            >
                {/* دکمه بستن در سمت چپ */}
                <IconButton
                    size="small"
                    onClick={() => setOpenModalRegister(false)}
                    sx={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        color: "text.disabled",
                        bgcolor: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.04)",
                        borderRadius: "50%",
                        transition: "all 0.2s ease",
                        "&:hover": {
                            bgcolor: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)",
                            color: "text.primary"
                        }
                    }}
                >
                    <CloseRounded fontSize="small" />
                </IconButton>

                {/* سربرگ مدرن با آیکون در سمت راست */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                    <Box
                        sx={{
                            width: 44,
                            height: 44,
                            borderRadius: "14px",
                            bgcolor: isDark ? "rgba(231, 51, 62, 0.15)" : "rgba(231, 51, 62, 0.08)",
                            color: "primary.main",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0
                        }}
                    >
                        <AddLocationAltRounded sx={{ fontSize: 24 }} />
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <DialogTitle
                            sx={{
                                p: 0,
                                fontWeight: 900,
                                fontSize: "1.15rem",
                                color: "text.primary",
                                lineHeight: 1.3
                            }}
                        >
                            درخواست ثبت مجموعه
                        </DialogTitle>
                        <Typography
                            variant="caption"
                            sx={{ color: "text.secondary", fontSize: "0.75rem", display: "block", mt: 0.3 }}
                        >
                            معرفی باشگاه یا مرکز ورزشی جدید به جیم‌پین
                        </Typography>
                    </Box>
                </Box>

                <DialogContent sx={{ p: 0, my: 1 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            mb: 2.5,
                            color: "text.secondary",
                            lineHeight: 1.8,
                            fontSize: "0.85rem",
                        }}
                    >
                        جزئیات مجموعه را وارد کنید تا بررسی شود.
                    </Typography>

                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            fullWidth
                            label="نام مجموعه *"
                            name="gymName"
                            value={formData.gymName}
                            onChange={handleChange}
                            error={!!errors.gymName}
                            helperText={errors.gymName}
                            variant="outlined"
                            disabled={loading}
                            size="small"
                            sx={{
                                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                            }}
                        />
                        <TextField
                            fullWidth
                            label="آدرس دقیق مجموعه (شامل شهر و خیابان) *"
                            name="gymAddress"
                            value={formData.gymAddress}
                            onChange={handleChange}
                            error={!!errors.gymAddress}
                            helperText={errors.gymAddress}
                            variant="outlined"
                            disabled={loading}
                            size="small"
                        />
                        <TextField
                            fullWidth
                            label="شماره تماس مجموعه"
                            name="gymPhone"
                            value={formData.gymPhone}
                            onChange={handleChange}
                            error={!!errors.gymPhone}
                            helperText={errors.gymPhone}
                            variant="outlined"
                            disabled={loading}
                            size="small"
                            placeholder="۰۹۱۲..."
                        />
                        <TextField
                            fullWidth
                            label="توضیحات اضافی (اختیاری)"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            multiline
                            rows={3}
                            variant="outlined"
                            disabled={loading}
                            size="small"
                        />
                        {submitSuccess && (
                            <Typography variant="body2" color="success.main" align="center" sx={{ fontWeight: 700, mt: 1 }}>
                                پیشنهاد شما با موفقیت ثبت شد. ممنون از همکاری شما!
                            </Typography>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions sx={{ p: 0, pt: 2, display: "flex", gap: 1.5 }}>
                    <Button
                        fullWidth
                        disabled={loading}
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            flex: 1.5,
                            borderRadius: "12px",
                            py: 1.1,
                            fontWeight: 700,
                            bgcolor: "primary.main",
                            color: "#ffffff",
                            boxShadow: "0 4px 14px rgba(231, 51, 62, 0.35)",
                            "&:hover": { bgcolor: "primary.dark" }
                        }}
                    >
                        {loading ? "در حال ثبت..." : "ثبت درخواست"}
                    </Button>
                    <Button
                        fullWidth
                        disabled={loading}
                        variant="outlined"
                        onClick={() => setOpenModalRegister(false)}
                        sx={{
                            flex: 1,
                            borderRadius: "12px",
                            py: 1.1,
                            fontWeight: 700,
                            color: "text.secondary",
                            borderColor: "divider"
                        }}
                    >
                        لغو
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    const renderMenuItem = ({ title, icon, onClick, badge, href, external }) => (
        <ListItemButton
            key={title}
            onClick={onClick}
            component={href ? "a" : "div"}
            href={href}
            target={external ? "_blank" : undefined}
            rel={external ? "noopener noreferrer" : undefined}
            sx={{
                borderRadius: "14px",
                mx: 0.8,
                my: 0.35,
                px: 1.5,
                py: 0.9,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                    bgcolor: isDark ? "rgba(231, 51, 62, 0.12)" : "rgba(231, 51, 62, 0.05)",
                    "& .menu-icon-box": {
                        bgcolor: "primary.main",
                        color: "#ffffff",
                        transform: "scale(1.05)"
                    },
                    "& .menu-arrow": {
                        color: "primary.main",
                        opacity: 1,
                        transform: "translateX(-2px)"
                    }
                }
            }}
        >
            {/* سمت راست: آیکون در کنار تیتر */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0, flex: 1 }}>
                <Box
                    className="menu-icon-box"
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "11px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(231, 51, 62, 0.06)",
                        color: "primary.main",
                        flexShrink: 0,
                        transition: "all 0.2s ease"
                    }}
                >
                    {icon}
                </Box>
                <Typography
                    sx={{
                        fontSize: "0.88rem",
                        fontWeight: 700,
                        color: "text.primary",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}
                >
                    {title}
                </Typography>
                {badge != null && badge > 0 && (
                    <Badge
                        badgeContent={badge}
                        color="primary"
                        sx={{ mr: 1, "& .MuiBadge-badge": { fontWeight: 800, fontSize: "0.72rem" } }}
                    />
                )}
            </Box>

            {/* سمت چپ: فلش در انتها */}
            <ArrowBackIosNew
                className="menu-arrow"
                sx={{
                    fontSize: "0.72rem",
                    color: "text.disabled",
                    opacity: 0.5,
                    flexShrink: 0,
                    transition: "all 0.2s ease"
                }}
            />
        </ListItemButton>
    );

    const renderSubheader = (title) => (
        <ListSubheader
            sx={{
                textAlign: "left",
            }}
        >
            {title}
        </ListSubheader>
    );

    return (
        <>
            <Box
                sx={{
                    width: { xs: 290, sm: 320 },
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "background.paper",
                    overflow: "hidden",
                }}
            >
                {/* هدر بالایی با نام کاربر در راست و تغییر تم در چپ */}
                <Box
                    sx={{
                        p: 2,
                        pt: { xs: 2.5, sm: 3 },
                        pb: 2,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        bgcolor: isDark ? "rgba(255, 255, 255, 0.02)" : "rgba(0, 0, 0, 0.015)"
                    }}
                >
                    {/* اطلاعات کاربر: آواتار و نام کاربر */}
                    <Box
                        onClick={() => handleNav("/profile/edit")}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.4,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            minWidth: 0,
                            flex: 1,
                            "&:hover": { opacity: 0.85 }
                        }}
                    >
                        <Avatar
                            alt={currentUser?.FullName || "کاربر"}
                            src={getUserAvatarSrc(currentUser, 96)}
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: "14px",
                                background: "linear-gradient(135deg, #e7333e 0%, #b22831 100%)",
                                color: "#ffffff",
                                fontWeight: 800,
                                fontSize: "1.15rem",
                                boxShadow: "0 4px 12px rgba(231, 51, 62, 0.35)",
                                flexShrink: 0
                            }}
                        >
                            {currentUser?.FullName ? (
                                currentUser.FullName.trim().charAt(0)
                            ) : (
                                <PersonRounded sx={{ fontSize: "1.4rem" }} />
                            )}
                        </Avatar>
                        <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0, pr: 0.5 }}>
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: "0.95rem",
                                    color: "text.primary",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: 160
                                }}
                            >
                                {currentUser?.FullName || "کاربر جیم‌پین"}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: "text.secondary",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    lineHeight: 1.3
                                }}
                            >
                                {currentUser?.PhoneNumber || "پروفایل کاربری"}
                            </Typography>
                        </Box>
                    </Box>

                    {/* سوییچ تم خورشید / ماه */}
                    <IconButton
                        onClick={() => setMode(isDark ? "light" : "dark")}
                        title={isDark ? "تغییر به حالت روشن" : "تغییر به حالت تاریک"}
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "12px",
                            bgcolor: isDark ? "rgba(251, 191, 36, 0.12)" : "rgba(99, 102, 241, 0.08)",
                            color: isDark ? "#fbbf24" : "#6366f1",
                            border: isDark ? "1px solid rgba(251, 191, 36, 0.25)" : "1px solid rgba(99, 102, 241, 0.15)",
                            transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                            flexShrink: 0,
                            "&:hover": {
                                bgcolor: isDark ? "rgba(251, 191, 36, 0.22)" : "rgba(99, 102, 241, 0.16)",
                                transform: "rotate(15deg) scale(1.06)"
                            },
                            "&:active": {
                                transform: "scale(0.95)"
                            }
                        }}
                    >
                        {isDark ? (
                            <LightModeRounded sx={{ fontSize: "1.25rem" }} />
                        ) : (
                            <DarkModeRounded sx={{ fontSize: "1.25rem" }} />
                        )}
                    </IconButton>
                </Box>

                {/* لیست ناوبری با اسکرول نرم */}
                <Box
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        px: 1,
                        py: 1,
                        "&::-webkit-scrollbar": { width: 4 },
                        "&::-webkit-scrollbar-thumb": {
                            bgcolor: "rgba(0, 0, 0, 0.12)",
                            borderRadius: 4
                        }
                    }}
                >
                    <List component="nav" disablePadding>
                        {renderSubheader("خدمات اصلی")}
                        {renderMenuItem({
                            title: "مجموعه‌ها",
                            icon: <Grain fontSize="small" />,
                            onClick: () => handleNav("/places")
                        })}
                        {renderMenuItem({
                            title: "لیست علاقه‌مندی‌ها",
                            icon: <FavoriteBorder fontSize="small" />,
                            onClick: () => handleNav("/favorites"),
                            badge: favoritesCount
                        })}
                        {renderMenuItem({
                            title: "کیف پول",
                            icon: <Wallet fontSize="small" />,
                            onClick: () => handleNav("/wallet")
                        })}
                        {renderMenuItem({
                            title: "سبد خرید",
                            icon: <ShoppingCart fontSize="small" />,
                            onClick: () => handleNav("/basket"),
                            badge: userBasket?.InvoiceSubscribe?.length
                        })}
                        {renderMenuItem({
                            title: "بلیط‌ها",
                            icon: <BookOnline fontSize="small" />,
                            onClick: () => handleNav("/tickets")
                        })}

                        {renderSubheader("دسترسی‌ها")}
                        {renderMenuItem({
                            title: "پشتیبانی",
                            icon: <SupportAgent fontSize="small" />,
                            onClick: () => handleNav("/support")
                        })}

                        {renderSubheader("سیاست‌ها و پشتیبانی")}
                        {renderMenuItem({
                            title: "درخواست ثبت مجموعه",
                            icon: <HelpCenter fontSize="small" />,
                            onClick: () => setOpenModalRegister(true)
                        })}
                        {renderMenuItem({
                            title: "سوالات متداول",
                            icon: <HelpCenter fontSize="small" />,
                            href: "https://gympin.ir/faq",
                            external: true
                        })}
                        {renderMenuItem({
                            title: "شرایط و قوانین",
                            icon: <Gavel fontSize="small" />,
                            href: "https://gympin.ir/term-and-conditions",
                            external: true
                        })}
                        {renderMenuItem({
                            title: "تماس با ما",
                            icon: <Dialpad fontSize="small" />,
                            href: "https://gympin.ir/contact",
                            external: true
                        })}
                    </List>
                </Box>

                {/* فوتر منو: کپی‌رایت سمت راست و دکمه خروج سمت چپ */}
                <Box
                    sx={{
                        p: 1.75,
                        px: 2,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderTop: "1px solid",
                        borderColor: "divider",
                        bgcolor: isDark ? "rgba(255, 255, 255, 0.02)" : "rgba(0, 0, 0, 0.015)"
                    }}
                >
                    {/* کپی‌رایت در سمت راست */}
                    <Typography
                        variant="caption"
                        sx={{
                            color: "text.disabled",
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            userSelect: "none"
                        }}
                    >
                        جیم‌پین © ۲۰۲۶
                    </Typography>

                    {/* دکمه خروج در سمت چپ با آیکون در راست و متن در چپ */}
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => {
                            setOpenModalExit(true);
                        }}
                        sx={{
                            color: "error.main",
                            bgcolor: isDark ? "rgba(231, 51, 62, 0.15)" : "rgba(231, 51, 62, 0.08)",
                            borderRadius: "10px",
                            px: 1.5,
                            py: 0.6,
                            fontSize: "0.8rem",
                            fontWeight: 700,
                            display: "inline-flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 0.75,
                            transition: "all 0.2s ease",
                            "&:hover": {
                                bgcolor: "error.main",
                                color: "#ffffff"
                            }
                        }}
                    >
                        <PowerSettingsNew sx={{ fontSize: "1.1rem !important" }} />
                        <span>خروج</span>
                    </Button>
                </Box>
            </Box>
            {renderModalExit()}
            {renderModalRegister()}
        </>
    );
};

export default DrawerLayout;
